import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import enableEdition from './enableEdition';

export default (layoutId, proposalId) => (dispatch) => {
    const dataAlert = {
        confirmText: i18next.t('Continue'),
        messages: [
            i18next.t('Are you sure you want to modify this proposal?'),
            i18next.t('You can always DUPLICATE the proposal'),
        ],
        onSuccess: () => dispatch(enableEdition(layoutId, proposalId)),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
